import React, { useState } from "react";

import { useTranslation } from "react-i18next";

import { ImportFileLanguageAsync } from "@backend/LanguageRequests";
import { DownloadGlobalExampleCsv, ImportFileAsync } from "@backend/UserBookRequests";

import ImportOverviewPageView from "./ImportOverviewPage.View";

export function ImportOverviewPage() {
    const [t, i18n] = useTranslation();

    const [errors, setErrors] = useState();
    const [index, setIndex] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const [languageCode, setLanguageCode] = useState(null);
    const [returnData, setReturnData] = useState({});
    const [file, setFile] = useState(null);

    const importOptions = [
        { id: "global", name: t("Global") },
        { id: "translation", name: t("Translation") },
    ];

    const [impOption, setImpOption] = useState(importOptions[0].id);

    //#region Functions
    function changeLanguageCode(x) {
        if (x.id === "translation") {
            setLanguageCode(i18n.language);
        } else {
            setLanguageCode(null);
        }
        setImpOption(x.id);
    }

    async function submitImportChanges(event) {
        event.preventDefault();

        if (file) {
            setIsLoading(true);
            if (impOption == "translation") {
                let result = await ImportFileLanguageAsync(languageCode, file);
                setReturnData(result);
                setErrors(result.errors.slice(0, 9));
            } else {
                let result = await ImportFileAsync(file);
                setReturnData(result);
                setErrors(result.errors.slice(0, 9));
            }
            setIsLoading(false);
            setIndex(1);
        }
    }

    async function downloadExampleCsv() {
        await DownloadGlobalExampleCsv("example.csv");
    }

    function goBack() {
        setIndex(0);
    }

    //#endregion

    //#region Handlers
    function handleCarouselFormSubmit(event) {
        return submitImportChanges(event);
    }

    function handleImportDropdownChange(dataItem) {
        return changeLanguageCode(dataItem);
    }

    function handleBackButtonClick() {
        goBack();
    }

    function handleLanguageDropdownChange(language) {
        setLanguageCode(language.id);
    }

    function handleFileUploaderChange(file) {
        setFile(file);
    }

    function handleDownloadExampleButtonClick() {
        return downloadExampleCsv();
    }

    //#endregion

    return (
        <ImportOverviewPageView
            errors={errors}
            impOption={impOption}
            importOptions={importOptions}
            index={index}
            isLoading={isLoading}
            languageCode={languageCode}
            // @ts-ignore
            returnData={returnData}
            onBackButtonClick={handleBackButtonClick}
            onCarouselFormSubmit={handleCarouselFormSubmit}
            onFileUploaderChange={handleFileUploaderChange}
            onImportDropdownChange={handleImportDropdownChange}
            onLanguageDropdownChange={handleLanguageDropdownChange}
            onDownloadExampleButtonClick={handleDownloadExampleButtonClick}
        />
    );
}
